import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './WidgetIcon.module.css';
import DynamicIcon from '@components/dynamicIcon/dynamicIcon';
import { WIDGET_DEFAULT_ICON_NAME } from '@common/constants';
import SvgFromString from '@components/SvgFromString/SvgFromString';
import { isSvgString, addWhiteFillToSvg } from '@components/gates/common';

type Props = {
  icon?: string;
}

const WidgetIcon = (props: Props) => {
  const { icon } = props;

  // If icon is an SVG string, render it as SVG with white fill
  if (isSvgString(icon)) {
    return (
      <SvgFromString
        svgStr={addWhiteFillToSvg(icon || '')}
        className={styles.DynamicIcon}
        width={32}
        height={32}
      />
    );
  }

  // Otherwise, render as FontAwesome icon
  return (
    <DynamicIcon
      className={styles.DynamicIcon}
      iconName={icon}
      default={
        <FontAwesomeIcon icon={['fas', WIDGET_DEFAULT_ICON_NAME]} className={styles.DynamicIcon}/>
      }
    />
  );
};

export default WidgetIcon;
